import { categories } from "@/mocks/anime";

const quickLinks = [
  { label: "首页", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "动漫分类", href: "#category" },
  { label: "最新更新", href: "#update" },
  { label: "连播专区", href: "#binge" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-foreground-900 to-foreground-950 text-background-100">
      <div className="container-site grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <a href="#home" className="flex items-center gap-2">
            <span className="grid h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-heading text-2xl text-background-50">漫途动漫</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/70">
            卡通动漫综合免费看平台，坚持高清无广告、播放流畅，支持全集与一口气连播模式，
            让你连续补番一路到底、畅快开刷。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {["ri-weibo-line", "ri-bilibili-line", "ri-douban-line", "ri-mail-line"].map((icon) => (
              <a
                key={icon}
                href="#contact"
                className="grid h-10 w-10 items-center justify-center rounded-full border border-background-100/15 text-background-100/80 transition-colors hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
                aria-label="社交媒体链接"
              >
                <i className={`${icon} text-lg`} />
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="页脚导航">
          <h3 className="font-heading text-base text-background-50">快速导航</h3>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/70">
            {quickLinks.map((l) => (
              <li key={l.href + l.label}>
                <a href={l.href} className="inline-flex items-center gap-1.5 transition-colors hover:text-secondary-400">
                  <i className="ri-arrow-right-s-line text-xs" />
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-base text-background-50">热门分类</h3>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/70">
            {categories.slice(0, 6).map((c) => (
              <li key={c.name}>
                <a href="#category" className="inline-flex items-center gap-1.5 transition-colors hover:text-secondary-400">
                  <i className="ri-arrow-right-s-line text-xs" />
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-6 text-xs text-background-100/50 sm:flex-row">
          <p>© {new Date().getFullYear()} 漫途动漫 · 卡通动漫综合免费看，高清无广告一口气追番</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-fill text-secondary-500" />
            为热爱动漫的你而建
          </p>
        </div>
      </div>
    </footer>
  );
}